const SELECTORS = {
  media: '.transition--media',
  mediaAlt: '.transition--media-alt',
  inAndUp: '.transition--in-up',
  fadeIn: '.transition--fade-in',
  playerOverlay: '.transition--player-overlay'
}

class GlobalTransitions {
  constructor () {
    this.allElements = document.body.querySelectorAll(Object.values(SELECTORS).join(', '))
    this.animations = [
      {
        elements: document.body.querySelectorAll(SELECTORS.media),
        options: {
          root: null,
          rootMargin: '0% 0% -30%',
          threshold: 0.0
        },
        observer: undefined
      },
      {
        elements: document.body.querySelectorAll(SELECTORS.mediaAlt),
        options: {
          root: null,
          rootMargin: '0% 0% -30%',
          threshold: 0.0
        },
        observer: undefined
      },
      {
        elements: document.body.querySelectorAll(SELECTORS.inAndUp),
        options: {
          root: null,
          rootMargin: '0% 0% -5%',
          threshold: 0.0
        },
        observer: undefined
      },
      {
        elements: document.body.querySelectorAll(SELECTORS.fadeIn),
        options: {
          root: null,
          rootMargin: '0% 0% -5%',
          threshold: 0.0
        },
        observer: undefined
      },
      {
        elements: document.body.querySelectorAll(SELECTORS.playerOverlay),
        options: {
          root: null,
          rootMargin: '0% 0% -30%',
          threshold: 0.0
        },
        observer: undefined
      }
    ]

    this.init()
  }

  init() {
    this.prepareAnimatableElements()
    this.registerObservers()
  }

  registerObservers() {
    this.animations.forEach(animation => {
      animation.observer = new IntersectionObserver(observers => {
        this.handleAnimation(observers, animation)
      }, animation.options)
      animation.elements.forEach(element => {
        animation.observer.observe(element)
      })
    })
  }

  handleAnimation(entries, parent) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        parent.observer.unobserve(entry.target)
        entry.target.classList.remove('-transition')
      }
    })
  }

  prepareAnimatableElements() {
    const initialLoad = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) {
          entry.target.classList.add('-transition')
        }
      })
      initialLoad.disconnect()
    }, {
      root: null,
      rootMargin: '0%',
      threshold: 0.0
    })
    this.allElements.forEach(element => {
      initialLoad.observe(element)
    })
  }
}

/**
 * Add module objects alphabetically as needed
 * {
 *  selector: CSS selector for the target element(s)
 *  Source: Imported js class with a constructor. Constructor will be passed
 *      the target DOM element.
 * }
 */
export default {
  selector: 'body',
  Source: GlobalTransitions
}
